var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-h2"},[_c('h1',[_vm._v(_vm._s(_vm.captionTab))])])
}
var staticRenderFns = []

export { render, staticRenderFns }